import FeatureHeader from "pages/submittal-details/new-submittal-details/submittal-detail-header";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import { ProjectContext } from "context/ProjectProvider";
import { useContext, useMemo } from "react";
import { useManageFeatureInstanceDetails } from "entity-app/hooks/feature-details-page";
import { isProjectInIntegrationMode } from "utils/utils";
import SubmittalLinkedTopSection from "pages/submittal-details/new-submittal-details/components/submittal-linked-top-section";
import { FeatureTypes } from "entity-app/constants";

function PartnerSubmittalDetails() {
  const { projectId, submittalId } = useParams() as any;
  const history = useHistory();
  const {
    tokenContents,
    gqlClientForProject,
    projectDetails,
    columnHeaders: { submittalHeaderMap },
    projectIntegrationConfig
  } = useContext(ProjectContext);

  const { featureInstanceData, actions } = useManageFeatureInstanceDetails(
    submittalId,
    FeatureTypes.SUBMITTALS
  );

  const goBackToList = () => {
    history.push(`/project/${projectId}/submittals`);
  };

  const isIntegrationMode = isProjectInIntegrationMode(
    projectDetails ? projectDetails.mode : 0
  );

  const submittal = useMemo(() => {
    if (!featureInstanceData?.feature_submittals?.length) return null;
    return featureInstanceData?.feature_submittals[0];
  }, [featureInstanceData?.feature_submittals]);

  return (
    <div className="grow flex-col bg-ciq-gray-600">
      <FeatureHeader
        featureInstanceData={featureInstanceData}
        title="Submittal Details"
        subTitle=""
        actions={actions}
        number={featureInstanceData?.auto_inc_value}
        headerTitle={featureInstanceData?.title}
        disabled
        goBackToList={goBackToList}
        feature="SUBMITTALS"
        getTabIndex={() => {}}
        submittal={submittal}
        projectIntegrationConfig={projectIntegrationConfig}
        isIntegrationMode={isIntegrationMode}
        setRevisionMode={() => {}}
        submittalHeaderMap={submittalHeaderMap}
        tokenContents={tokenContents}
        setSubmittalViewState={() => {}}
        updateFeatureData={{
          localFeatureInstanceData: structuredClone(featureInstanceData),
          setLocalFeatureInstanceData: () => {}
        }}
        gqlClientForProject={gqlClientForProject}
        readOnlyMode
      />
      <div className="flex flex-col p-4 space-y-4">
        <SubmittalLinkedTopSection
          actions={actions}
          featureInstanceData={featureInstanceData}
          disableDB
        />
      </div>
    </div>
  );
}

export default PartnerSubmittalDetails;
